const barList = [{
		name: '数据统计',
		icon: 'el-icon-s-shop',
		children: [{
				path: '/home',
				name: '统计图表',
				icon: 'el-icon-pie-chart'
			}
		]
	},
	{
		name: '用户管理',
		icon: 'el-icon-user-solid',
		children: [{
				path: '/userManage/firstpage',
				name: '用户列表',
				icon: 'el-icon-user'
			},
			{
				path: '/userManage/vipsetting',
				name: '会员设置',
				icon: 'el-icon-medal-1'
			}
		]
	},
	{
		name: '业务员管理',
		icon: 'el-icon-s-custom',
		children: [{
				path: '/salesmanManage/firstpage',
				name: '业务员列表',
				icon: 'el-icon-user'
			}
			,
			{
				path: '/salesmanManage/yejiStatistics',
				name: '业绩统计',
				icon: 'el-icon-s-data'
			}
		]
	},
	// {
	// 	name: '分销管理',
	// 	icon: 'el-icon-share',
	// 	children: [{
	// 			path: '/distribution/index',
	// 			name: '分销员管理',
	// 			icon: 'el-icon-user'
	// 		},
	// 		{
	// 			path: '/distribution/statistics',
	// 			name: '分销统计',
	// 			icon: 'el-icon-s-data'
	// 		},
	// 		{
	// 			path: '/distribution/tixianList',
	// 			name: '分销提现',
	// 			icon: 'el-icon-coin'
	// 		},
	// 		{
	// 			path: '/distribution/setting',
	// 			name: '分销设置',
	// 			icon: 'el-icon-setting'
	// 		}
	// 	]
	// },
	// {
	// 	name: '代收点管理',
	// 	icon: 'el-icon-s-flag',
	// 	children: [{
	// 			path: '/teamManage/siteList',
	// 			name: '代收点列表',
	// 			icon: 'el-icon-menu'
	// 		}
	// 		,
	// 		{
	// 			path: '/teamManage/checkingSite',
	// 			name: '待审核列表',
	// 			icon: 'el-icon-s-check'
	// 		}
	// 		,
	// 		{
	// 			path: '/teamManage/yejiStatistics',
	// 			name: '核销统计',
	// 			icon: 'el-icon-s-data'
	// 		}
	// 	]
	// },
	{
		name: '商品管理',
		icon: 'el-icon-s-goods',
		children: [{
				path: '/goods/category',
				name: '商品分类',
				icon: 'el-icon-s-help'
			},
			{
				path: '/goods/goodsList',
				name: '商品列表',
				icon: 'el-icon-menu'
			},
			{
				path: '/goods/historyGoods',
				name: '历史商品',
				icon: 'el-icon-delete-solid'
			},
			{
				path: '/goods/yunfeiModel',
				name: '运费模板',
				icon: 'el-icon-set-up'
			}
		]
	},
	// {
	// 	name: '促销活动',
	// 	icon: 'el-icon-message-solid',
	// 	children: [{
	// 			path: '/promotion/miaosha',
	// 			name: '限时秒杀',
	// 			icon: 'el-icon-alarm-clock'
	// 		},
	// 		{
	// 			path: '/promotion/tuangou',
	// 			name: '团购活动',
	// 			icon: 'el-icon-s-flag'
	// 		},
	// 		{
	// 			path: '/promotion/coupon',
	// 			name: '优惠券',
	// 			icon: 'el-icon-s-ticket'
	// 		},
	// 		// {
	// 		// 	path: '/promotion/manjian',
	// 		// 	name: '满减活动',
	// 		// 	icon: 'el-icon-finished'
	// 		// }
	// 	]
	// },
	// {
	// 	name: '订单管理',
	// 	icon: 'el-icon-s-order',
	// 	children: [{
	// 			path: '/order/orderlist',
	// 			name: '待处理',
	// 			icon: 'el-icon-s-order'
	// 		},
	// 		{
	// 			path: '/order/inTransit',
	// 			name: '运输中',
	// 			icon: 'el-icon-truck'
	// 		},
	// 		{
	// 			path: '/order/afterSaleOrder',
	// 			name: '售后订单',
	// 			icon: 'el-icon-s-release',
	// 		},
	// 		{
	// 			path: '/order/historyOrder',
	// 			name: '历史订单',
	// 			icon: 'el-icon-s-claim'
	// 		},
	// 		// {
	// 		// 	// path: '/order/afterSaleOrder',
	// 		// 	name: '售后订单',
	// 		// 	icon: 'el-icon-s-release',
	// 		// 	children: [{
	// 		// 			path: '/order/afterSaleOrder',
	// 		// 			name: '普通售后',
	// 		// 			icon: 'el-icon-s-release',
	// 		// 		},
	// 		// 		{
	// 		// 			path: '/order/afterTuangouSaleOrder',
	// 		// 			name: '团购售后',
	// 		// 			icon: 'el-icon-s-release',
	// 		// 		}
	// 		// 	]
	// 		// },

	// 		// {
	// 		//     path: '/order/wuliu',
	// 		//     name: '导入表格',
	// 		//     icon: 'el-icon-document-copy'
	// 		// },
	// 		// {
	// 		//     path: '/search',
	// 		//     name: '地图搜索',
	// 		//     icon: 'el-icon-location'
	// 		// }
	// 	]
	// },
	// {
	// 	name: '秒杀订单',
	// 	icon: 'el-icon-eleme',
	// 	children: [{
	// 			path: '/miaosha/miaoshaOrder',
	// 			name: '待处理',
	// 			icon: 'el-icon-s-order'
	// 		},
	// 		{
	// 			path: '/miaosha/miaoshaInTransit',
	// 			name: '运输中',
	// 			icon: 'el-icon-truck'
	// 		},
	// 		{
	// 			path: '/miaosha/afterMiaoshaSaleOrder',
	// 			name: '秒杀售后',
	// 			icon: 'el-icon-s-release',
	// 		},
	// 		{
	// 			path: '/miaosha/miaoshaHistoryOrder',
	// 			name: '历史订单',
	// 			icon: 'el-icon-s-claim',
	// 		},
	// 	]
	// },
	// {
	// 	name: '团购订单',
	// 	icon: 'el-icon-attract',
	// 	children: [{
	// 			path: '/tuangou/tuangouOrder',
	// 			name: '待处理',
	// 			icon: 'el-icon-s-order'
	// 		},
	// 		{
	// 			path: '/tuangou/tuangouInTransit',
	// 			name: '运输中',
	// 			icon: 'el-icon-truck'
	// 		},
	// 		{
	// 			path: '/tuangou/afterTuangouSaleOrder',
	// 			name: '团购售后',
	// 			icon: 'el-icon-s-release',
	// 		},
	// 		{
	// 			path: '/tuangou/tuangouHistoryOrder',
	// 			name: '历史订单',
	// 			icon: 'el-icon-s-claim',
	// 		},
	// 	]
	// },
	// {
	// 	name: '商品评价',
	// 	icon: 'el-icon-s-comment',
	// 	children: [{
	// 			name: '普通商品',
	// 			path: '/goodsComments/goodsComments',
	// 			icon: 'el-icon-s-comment',
	// 		},
	// 		{
	// 			name: '团购评价',
	// 			path: '/goodsComments/tuangouComments',
	// 			icon: 'el-icon-s-comment',
	// 		}
	// 	]
	// }, {
	// 	name: '系统设置',
	// 	path: '/setting',
	// 	icon: 'el-icon-s-tools'
	// }
]

export default barList
